<po-page-default [p-title]="page.title" [p-breadcrumb]="page.breadcrumb" [p-actions]="page.actions">

    <po-table [p-columns]="tableColumns" [p-items]="tableItems" p-sort="true" p-striped="true" p-hide-text-overflow="true" [p-height]="tableHeight" p-selectable="true" p-single-select="true" (p-selected)="selected($event)" (p-unselected)="unSelected($event)">
    </po-table>

    <app-pagination [(currentPage)]="pagination.currentPage" (pageChanged)="onPageChange($event)" [(totalItems)]="pagination.totalItems" [itemsPerPage]="pagination.itemsPerPage">
    </app-pagination>

</po-page-default>

<po-modal #anexoModal p-title="Conhecimento">
    <!-- ENVIAR QUAL A NOTA QUE ESTOU ENVIANDO () -->
    <div class="po-row">
        <po-upload class="po-md-3" [p-url]="uploadURL" (p-upload)="anexaArquivo($event)">
        </po-upload>

        <po-button p-icon="po-icon po-icon-eye-off" [p-label]="labelButton" (click)="exibeFiles()"></po-button>

        <po-button *ngIf="item.length > 0 " class="po-md-5" p-icon="po-icon po-icon-download" p-label="Baixar arquivos selecionados" (click)="downloadFiles()"></po-button>
    </div>

    <po-table *ngIf="mostrarArquivos" [p-columns]="tableConhecimentoColumns" [p-items]="tableConhecimentoItems" p-sort="true" p-striped="true" p-selectable="true" (p-selected)="selectedItem($event)" (p-unselected)="unSelectedItem($event)" (p-all-selected)="allSelectedItem($event)"
        (p-all-unselected)="unAllSelectedItem($event)">
    </po-table>
</po-modal>

<po-loading-overlay *ngIf="loading" p-text="Carregando"></po-loading-overlay>